import { Component, OnInit, Input } from "@angular/core";

interface ValidObject {
  invalid: boolean;
  dirty: boolean;
  touched: boolean;
  errors: {
    required: boolean;
    pattern: string;
    email: string;
    minlength: number;
  };
}

@Component({
  selector: "app-display-error",
  templateUrl: "./display-error.component.html"
})
export class DisplayErrorComponent implements OnInit {
  @Input() model: ValidObject;

  constructor() {}

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/shared/error/display-error.component.ts